import axios from "axios";

export const getLoginApi = (data) => {

	const baseUrl = process.env.REACT_APP_BASE_URL_TWO;

  return axios.post(`${baseUrl}users/api/v1/users/regional-admin/login/`, data)

  .then((res)=>{
   
    return res;
  })
  .catch((err)=>{
   
    return err;
  })

}
